import { LinearProgress } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { artifactAtom } from '../../stores/jotai/artifacts/artifacts';
import { getQuoteData, getVultrKeyFromArtifactID } from '../../stores/jotai/base';
import { interviewsAtom } from '../../stores/jotai/interviews/interviews';
import CollapsibleTypography from '../generics/components/collapsible-typography';

function checkForStringifiedData(data: any) {
    if (typeof data === 'string') {
        let hasUnderlyingCache = false;

        try {
            if (JSON.parse(data).textCache !== undefined) {
                hasUnderlyingCache = true;
            }
        }
        catch (e) {

        }

        if (hasUnderlyingCache) {
            return JSON.parse(data);
        }
        else {
            return data;
        }
    }
    else {
        return data;
    }
}

export default function MaterialQuoteView(props: any) {
    const { keycloak, initialized } = useKeycloak()
    const [data, setData] = useState(false);
    const [quoteCache, setQuoteCache] = useState(undefined);
    const [allInterview,]=useAtom(interviewsAtom);
    const [artifacts,]=useAtom(artifactAtom);

    const { artifactID, selection, quouteCollapseLength, selected, isInsightTable=false, onReadMoreClick, isItalic } = props;

    const safeSelection = checkForStringifiedData(selection);

    useEffect(() => {
        setData(false);

        const vultrKey = getVultrKeyFromArtifactID(artifacts, artifactID,allInterview);

        if (safeSelection === null || safeSelection === undefined) {
            return;
        }
        else {

            if (safeSelection.textCache !== undefined) {
                setData(true);
                setQuoteCache(safeSelection.textCache);
            }
            else {
                getQuoteData(keycloak.token, vultrKey, safeSelection).then((quoteData: any) => {
                    setData(quoteData);

                    // TODO: I need to bring this back, but with more robust caching
                    //setQuoteCache(quoteData.quote);
                });
            }
        }
    }, [artifactID, safeSelection])

    if (quoteCache === undefined) {
        if (data === false) {
            return <LinearProgress />
        }
    }

    let incomingQuote = (quoteCache ? quoteCache : data.quote);
    let renderDecoration = '"'; // should a char be put and the start and end of the quote
    let incomingFontStyle = 'italic'; // should the quote be italicized

    if (incomingQuote === undefined || incomingQuote === null || incomingQuote === "undefined") {
        incomingQuote = "";
        renderDecoration = "";
    }

    return (
        <CollapsibleTypography
            quote={incomingQuote}
            fontStyle={incomingFontStyle}
            quoteDecoration={renderDecoration}
            quouteCollapseLength={quouteCollapseLength}
            selected={selected}
            isInsightTable={isInsightTable}
            onClick={onReadMoreClick}
            isItalic = {isItalic}
        />
    );
}
MaterialQuoteView.defaultProps = {
  selected: false,
  isInsightTable: false,
  isItalic:true,
  onReadMoreClick: () => {},
};